<template>
  <div class="date-filter-container">
    <el-radio-group class="select-content" v-model="value.fixedValue">
      <el-radio class="select-content-li" v-for="item in fixedArr" :key="item.val" :label="item.val">
        <span>日期（{{ item.label }}）</span>
      </el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: {
        fixedValue: 'year',
        rangeValue: []
      },
      fixedArr: [
        { val: 'year', label: '年' },
        // { val: 'quarter', label: '季' },
        { val: 'month', label: '月' },
        // { val: 'week', label: '周' },
        { val: 'day', label: '日' }
      ]
    };
  },
  props: {
    fieldItem: {
      type: Object,
      required: true
    }
  },
  created() {
    let valueOfFilter = this.fieldItem.valueOfFilter;
    if (valueOfFilter) {
      valueOfFilter = JSON.parse(valueOfFilter);
    }
    if (valueOfFilter) {
      this.value = { ...this.value, ...(valueOfFilter || {}) };
    }
  },
  methods: {
    validateInfo() {
      return this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.date-filter-container {
  .select-content {
    padding: 15px 20px;

    .select-content-li {
      display: block;
      margin-top: 10px;

      &:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>
